import api from "../../../utils/useApi";
import AviableAddress from "../../../utils/useAviableAddress";
import { STATE_CONSTANTS_ADDRESS } from "../../../utils/useConstantState";
import {
  FunctionCheckArea,
  FunctionCheckIsBKK,
} from "../../../utils/useFunction";

export const mockDataAddress = {
  address_components: [
    {
      long_name: "991",
      short_name: "991",
      types: ["street_number"],
    },
    {
      long_name: "Rama I Road",
      short_name: "Rama I Rd",
      types: ["route"],
    },
    {
      long_name: "Khwaeng Pathum Wan",
      short_name: "Khwaeng Pathum Wan",
      types: ["sublocality_level_2", "sublocality", "political"],
    },
    {
      long_name: "Khet Pathum Wan",
      short_name: "Khet Pathum Wan",
      types: ["sublocality_level_1", "sublocality", "political"],
    },
    {
      long_name: "Krung Thep Maha Nakhon",
      short_name: "Krung Thep Maha Nakhon",
      types: ["administrative_area_level_1", "political"],
    },
    {
      long_name: "Thailand",
      short_name: "TH",
      types: ["country", "political"],
    },
    {
      long_name: "10330",
      short_name: "10330",
      types: ["postal_code"],
    },
  ],
  formatted_address:
    "991 Rama I Rd, Khwaeng Pathum Wan, Khet Pathum Wan, Krung Thep Maha Nakhon 10330, Thailand",
  geometry: {
    location: {
      lat: 13.7462411,
      lng: 100.5347402,
    },
    viewport: {
      northeast: {
        lat: 13.74856255,
        lng: 100.53709195,
      },
      southwest: {
        lat: 13.74461955,
        lng: 100.53273455,
      },
    },
  },
  name: "Siam Paragon",
  place_id: "ChIJIeWu482e4jARYymvLJqTQ58",
  html_attributions: [],
  adr_address:
    '<span class="street-address">991 Rama I Rd</span>, <span class="extended-address">Khwaeng Pathum Wan</span>, <span class="locality">Khet Pathum Wan</span>, <span class="region">Krung Thep Maha Nakhon</span> <span class="postal-code">10330</span>, <span class="country-name">Thailand</span>',
  business_status: "OPERATIONAL",
  current_opening_hours: {
    open_now: true,
    periods: [
      {
        close: {
          date: "2023-03-05",
          day: 0,
          time: "2200",
        },
        open: {
          date: "2023-03-05",
          day: 0,
          time: "1000",
        },
      },
      {
        close: {
          date: "2023-03-06",
          day: 1,
          time: "2200",
        },
        open: {
          date: "2023-03-06",
          day: 1,
          time: "1000",
        },
      },
      {
        close: {
          date: "2023-02-28",
          day: 2,
          time: "2200",
        },
        open: {
          date: "2023-02-28",
          day: 2,
          time: "1000",
        },
      },
      {
        close: {
          date: "2023-03-01",
          day: 3,
          time: "2200",
        },
        open: {
          date: "2023-03-01",
          day: 3,
          time: "1000",
        },
      },
      {
        close: {
          date: "2023-03-02",
          day: 4,
          time: "2200",
        },
        open: {
          date: "2023-03-02",
          day: 4,
          time: "1000",
        },
      },
      {
        close: {
          date: "2023-03-03",
          day: 5,
          time: "2200",
        },
        open: {
          date: "2023-03-03",
          day: 5,
          time: "1000",
        },
      },
      {
        close: {
          date: "2023-03-04",
          day: 6,
          time: "2200",
        },
        open: {
          date: "2023-03-04",
          day: 6,
          time: "1000",
        },
      },
    ],
    weekday_text: [
      "Monday: 10:00 AM – 10:00 PM",
      "Tuesday: 10:00 AM – 10:00 PM",
      "Wednesday: 10:00 AM – 10:00 PM",
      "Thursday: 10:00 AM – 10:00 PM",
      "Friday: 10:00 AM – 10:00 PM",
      "Saturday: 10:00 AM – 10:00 PM",
      "Sunday: 10:00 AM – 10:00 PM",
    ],
  },
  delivery: true,
  dine_in: true,
  editorial_summary: {
    language: "en",
    overview:
      "Expansive mall with high-end & mainstream boutiques, dining, an aquarium, bowling & a multiplex.",
  },
  formatted_phone_number: "02 690 1000",
  icon: "https://maps.gstatic.com/mapfiles/place_api/icons/v1/png_71/shopping-71.png",
  icon_background_color: "#4B96F3",
  icon_mask_base_uri:
    "https://maps.gstatic.com/mapfiles/place_api/icons/v2/shopping_pinlet",
  international_phone_number: "+66 2 690 1000",
  opening_hours: {
    open_now: true,
    periods: [
      {
        close: {
          day: 0,
          time: "2200",
        },
        open: {
          day: 0,
          time: "1000",
        },
      },
      {
        close: {
          day: 1,
          time: "2200",
        },
        open: {
          day: 1,
          time: "1000",
        },
      },
      {
        close: {
          day: 2,
          time: "2200",
        },
        open: {
          day: 2,
          time: "1000",
        },
      },
      {
        close: {
          day: 3,
          time: "2200",
        },
        open: {
          day: 3,
          time: "1000",
        },
      },
      {
        close: {
          day: 4,
          time: "2200",
        },
        open: {
          day: 4,
          time: "1000",
        },
      },
      {
        close: {
          day: 5,
          time: "2200",
        },
        open: {
          day: 5,
          time: "1000",
        },
      },
      {
        close: {
          day: 6,
          time: "2200",
        },
        open: {
          day: 6,
          time: "1000",
        },
      },
    ],
    weekday_text: [
      "Monday: 10:00 AM – 10:00 PM",
      "Tuesday: 10:00 AM – 10:00 PM",
      "Wednesday: 10:00 AM – 10:00 PM",
      "Thursday: 10:00 AM – 10:00 PM",
      "Friday: 10:00 AM – 10:00 PM",
      "Saturday: 10:00 AM – 10:00 PM",
      "Sunday: 10:00 AM – 10:00 PM",
    ],
  },
  photos: [
    {
      height: 4032,
      html_attributions: [
        '<a href="https://maps.google.com/maps/contrib/101169027047975104779">Paul Sz</a>',
      ],
      photo_reference:
        "AfLeUgNhayUObRDr0708pZ0L3f4ak982QPQl4hqs3dtmcUonu350mwMLeRt8TZqPhfHCStCGCxSIs6zsKkq-CWP7UBfB3natrmQ7bQ1JTwR0SLN6t9f8tuImTntYdmY7x0cMMUNRQvKW9hnn6A3jDRsw4rZXePmekMww4Uk8F0OsMUdEhU3_",
      width: 2268,
    },
    {
      height: 3024,
      html_attributions: [
        '<a href="https://maps.google.com/maps/contrib/103260032815599474801">Wihok203</a>',
      ],
      photo_reference:
        "AfLeUgOQ5qPO0q1Acd2h1bCPsM8T1say0ttBVsZd2q5ra-VwpnqnsRsIolu4a7K7W9IP9T9IYE0GYVqQ4Gm2-5oyXDoF-MO-196yA2BIOzHNcZpu17LGokxSiZFJzS4XZaftGXvT48QJ24V88knOMiIi7K20W07S4rk0-UkYOPyWsqwcE7SO",
      width: 4032,
    },
    {
      height: 3024,
      html_attributions: [
        '<a href="https://maps.google.com/maps/contrib/115827087166430807003">Lee Jiaw Siang</a>',
      ],
      photo_reference:
        "AfLeUgO4-1hM2l0gpZxrBYXSHdvSDLLaUivrhd5kCqWyBLKakg1KVU-edVnEsFdDTNW4CJfDnrRo91GNTrJgLPhIuVG24FTSIkNkoUkOiXOBmYwQq0zuTnN048bucWoDi2oP20thZJSyikfJ-EmJT3NBPZfuFHfOzwO-8t6Lcg0nhnAaSa9e",
      width: 4032,
    },
    {
      height: 3024,
      html_attributions: [
        '<a href="https://maps.google.com/maps/contrib/110286993977881546195">SAM SHIH</a>',
      ],
      photo_reference:
        "AfLeUgMFD7U8KZV1fW-8QnNYoO-cGw8w6U8IRXcTV0b-70CPKA05kizSsJnifgAQRj1o1xxGlk0RL6Cqea1sX4adtTCyLZ4a1Ji6lRbccdFeKFJrsGOpXqcaedLB1mwq9LAjPcgc22VFQ9g4xberJUbyd8WmzhaU2GC2eOkJvIoN9mxTM03N",
      width: 4032,
    },
    {
      height: 3024,
      html_attributions: [
        '<a href="https://maps.google.com/maps/contrib/110143670533279764358">Sashitha Imalka</a>',
      ],
      photo_reference:
        "AfLeUgP2nsaBKbspVScApkfuSo0pYiLuWfzoDj--uOlbHfX-ho4dBrfv335jASA2XlSPrjYtL9JgB0hlwetj4oxOFzRGZIzY_QCqvbbB2cQN1amfIIz0CCxLr53J8Z32MT1ApSb-O6KU7kxu2BSTAZ00PMSUlxIuvbu5jfo3gcohE6FFbXUg",
      width: 4032,
    },
    {
      height: 3024,
      html_attributions: [
        '<a href="https://maps.google.com/maps/contrib/101999777612811489126">noora_chan_</a>',
      ],
      photo_reference:
        "AfLeUgM0cVh6nOIWPrvA2mNO4O4TFCy7347ZBkCgKg7bmldoDuu9xRJk181Uwl7wM2WcpbXsDhh7Z91CA6U4Pk2ho7rbgvvrOZNzMsXy-aASqbK9jctKnP7nbuPBpfczJ5MY4soh06gRYOlYk91Hc-19LRFm6yTgjcDPyoPuSrRsk8SAEWb4",
      width: 4032,
    },
    {
      height: 3072,
      html_attributions: [
        '<a href="https://maps.google.com/maps/contrib/113136796467648657980">Songsit Nüng Lertsethtakarn</a>',
      ],
      photo_reference:
        "AfLeUgNuX65vZXZz1HOETGmRkuSC4E8lz_-2Hn-_EqOSzdcl5qszg-9wd_q1T7PnHq3Y4gyfI5ICNUVWfIXMUdaT5hoXcypnWeHsRrTeWnQDdt3qxhqBFgbB0YQAo5iTls8Y5yI7dFiv6kB7Rg9Y4Kl0ygbDq3ybiCRKxIR1P9MT_sGVyTFU",
      width: 4096,
    },
    {
      height: 3024,
      html_attributions: [
        '<a href="https://maps.google.com/maps/contrib/110143670533279764358">Sashitha Imalka</a>',
      ],
      photo_reference:
        "AfLeUgP5JK6b5LpkpfxSReLZ6SMmSql0gH2okD-B6K2FFwB28HWJtGvantX3IIO60sCy45Doixc5Pk4EM8E8JfJf1xYqXsp_KYu-8JYlfXNUe9UlmPjSg0WbJfXU2-C3duCd4glZGTsCv7ubGMu81JRoTHVWvdBkjFzq1gdOE-dL7IK845kN",
      width: 4032,
    },
    {
      height: 2988,
      html_attributions: [
        '<a href="https://maps.google.com/maps/contrib/112070349579690737956">Kittidech Nimwongjaroeensuk</a>',
      ],
      photo_reference:
        "AfLeUgNjytDszl9oZpRa03jUO-Q-CjWCGTAIFRSe6nuozI8MR0g1V47QUzQzPQ-gPjJOaUmSKghpaYdkj7bEzj8NPHCoWUvIuqNXP5JRl7VVNRqCV8-cqWcqQ-z08XmvZ5_nKuMkywK0cPhUm6Wx1GmHkvk_7ouh2BS27UDysksAtq40fp0x",
      width: 5312,
    },
    {
      height: 4032,
      html_attributions: [
        '<a href="https://maps.google.com/maps/contrib/104680855365029683430">Josh T.</a>',
      ],
      photo_reference:
        "AfLeUgOQJA4RdYk5nGMDXpX38eeil3FMoCmKutHVYHnnIgCERjnYQ9pIBdO9y3nxSQG6-lnYe8pz6_-5RJmJFqo2ZFmZUdfxu_JY_4G7dt_ZrzZpeago3CFYPr7UrCNhGoMDdXMfAuw-bhXCSdkiBFjq-74ByrkuDuEEkC8lcFrkPiZ-t0mk",
      width: 3024,
    },
  ],
  plus_code: {
    compound_code: "PGWM+FV Bangkok, Thailand",
    global_code: "7P52PGWM+FV",
  },
  price_level: 2,
  rating: 4.5,
  reference: "ChIJIeWu482e4jARYymvLJqTQ58",
  reviews: [
    {
      author_name: "Rommel Lagmay",
      author_url:
        "https://www.google.com/maps/contrib/105090461547448816059/reviews",
      language: "en",
      original_language: "en",
      profile_photo_url:
        "https://lh3.googleusercontent.com/a-/ACB-R5QR1bKvM9-xAylUiUIqRtEj0vuEnWOdUx1w0CjmGw=s128-c0x00000000-cc-rp-mo-ba6",
      rating: 5,
      relative_time_description: "3 months ago",
      text: "One of the best malls not only in Thailand but around the world! All top brands are here. Their department store has amazing selection to choose from. The food court is simply amazing. Their grocery has tons of things to buy. Really beautiful! The mall is strategically located just outside the train station. The mall is within a huge shopping complex owned by one management. It’s very busy during weekends so be sure to come early to get parking in case you’re driving your car.",
      time: 1668361373,
      translated: false,
    },
    {
      author_name: "DUNG TRAN",
      author_url:
        "https://www.google.com/maps/contrib/116793187819710648292/reviews",
      language: "en",
      original_language: "en",
      profile_photo_url:
        "https://lh3.googleusercontent.com/a/AGNmyxYL-_NjtVyzOk_jizGf1vtFWvZpxpG1AtUU6isS=s128-c0x00000000-cc-rp-mo-ba5",
      rating: 5,
      relative_time_description: "9 months ago",
      text: "Big shopping mall with big brands and Thai brands\nFood court there has a lots of choices for you. Cheap and tasty. Need use cash to get a Card, then you can move around to take what you want. Changes will be back later when you return card to counter.\nCrowded there. From G floor can walk to another shopping mall. Can try to find out your best route for shopping. Enjoy…..",
      time: 1653121000,
      translated: false,
    },
    {
      author_name: "Chawin OMFS",
      author_url:
        "https://www.google.com/maps/contrib/101565370497150393842/reviews",
      language: "en",
      original_language: "en",
      profile_photo_url:
        "https://lh3.googleusercontent.com/a-/ACB-R5S096FPAMACMXZGTNetocbzOKDml32NhkmgGd7W=s128-c0x00000000-cc-rp-mo-ba5",
      rating: 5,
      relative_time_description: "a year ago",
      text: "Located at the same floor of movie theaters. Multiple choices of espresso-and-tea based beverages available with special 40-baht discount  off any drink when you show the barista the movie ticket as of now.",
      time: 1639830583,
      translated: false,
    },
    {
      author_name: "Fawzi Alwosaibai",
      author_url:
        "https://www.google.com/maps/contrib/108060846158201655976/reviews",
      language: "en",
      original_language: "en",
      profile_photo_url:
        "https://lh3.googleusercontent.com/a-/ACB-R5T1p0SWYzcIGWfbQ4RiYFUHX55YSKNiRxYPxFtseA=s128-c0x00000000-cc-rp-mo-ba6",
      rating: 3,
      relative_time_description: "4 months ago",
      text: "A very big mall but a lot of the shops are closed. It seems they didn't fully recovered from COVID-19. The available shops are nice and offer a wide range of merchandise. It's a nice place to spend a day shopping and eating with the whole family.  It's very close to Siam train station which makes it very convenient.",
      time: 1666499707,
      translated: false,
    },
    {
      author_name: "Logan Saunders",
      author_url:
        "https://www.google.com/maps/contrib/101198984242139608649/reviews",
      language: "en",
      original_language: "en",
      profile_photo_url:
        "https://lh3.googleusercontent.com/a/AGNmyxbFz4Qa90oZwRiwS78zReyGPwoar-aiSIYsscEN=s128-c0x00000000-cc-rp-mo-ba6",
      rating: 4,
      relative_time_description: "a year ago",
      text: "A Canadian Tourist Review: It is a humongous mall! It is very easy to get lost due to its sheer size. Lots of decorations and a stage set up with a live orchestra. Very busy place. A good chunk of the food court only uses a special app rather than accepting cash or credit. Fun area to explore!",
      time: 1640585835,
      translated: false,
    },
  ],
  takeout: true,
  types: [
    "shopping_mall",
    "department_store",
    "point_of_interest",
    "store",
    "establishment",
  ],
  url: "https://maps.google.com/?cid=11476178565854079331",
  user_ratings_total: 47617,
  utc_offset: 420,
  vicinity: "991 Rama I Road, Khwaeng Pathum Wan, Khet Pathum Wan",
  website: "https://www.siamparagon.co.th/",
  wheelchair_accessible_entrance: true,
  lat: 13.7462411,
  lng: 100.5347402,
  link: "https://maps.google.com/?cid=11476178565854079331",
  isAvailable: true,
  location: "BANGKOK",
};

export const FunctionSetSelectedLocationFromLatLng = async (
  lat,
  lng,
  setSelectedLocation,
  setAddress
) => {
  const isAvailable = FunctionCheckArea(AviableAddress, {
    lat: lat,
    lng: lng,
  });

  let thisMarker = {
    lat: 0,
    lng: 0,
    description: "",
    isAvailable: false,
  };
  thisMarker.lat = lat;
  thisMarker.lng = lng;
  thisMarker.isAvailable = isAvailable;

  const {
    data: { recived },
  } = await api.post("/address/findMarker", {
    lat: lat,
    lng: lng,
  });

  thisMarker = {
    ...thisMarker,
    ...recived,
  };

  thisMarker.description = recived?.name;
  thisMarker.link = recived?.url;
  thisMarker.location = FunctionCheckIsBKK(recived?.address_components);

  if (setAddress && isAvailable) {
    setAddress(thisMarker);
    setSelectedLocation("");
  } else {
    setSelectedLocation(thisMarker);
  }
};

const AddressOnClickCurrentLocation = (
  setTab = false,
  setSelectedLocation = false,
  setAddress = false
) => {
  if (navigator.geolocation) {
    console.log("CURRENT LOCATION IS ON");
    navigator.geolocation.getCurrentPosition(async function (position) {
      FunctionSetSelectedLocationFromLatLng(
        position.coords.latitude,
        position.coords.longitude,
        setSelectedLocation,
        setAddress
      );
    });
  }
  if (setTab) {
    setTab(STATE_CONSTANTS_ADDRESS.FOUND);
  }
};

export default AddressOnClickCurrentLocation;
